import React from "react";

import { ContentWrapper } from "../components/Nav";
import "./styles/Refer.scss";

export default class Refer extends React.Component {
  state = { emailList: "" };

  render() {
    return (
      <ContentWrapper style={{ backgroundColor: "white" }}>
        <div className="headerImage" />
        <div className="referContainer">
          <div className="referInput">
            <input
              placeholder="Refer friends by email address"
              value={this.state.emailList}
              onChange={evt => this.setState({ emailList: evt.target.value })}
            />
            <button className="sendButton">Send</button>
            <button className="sendOther">
              <img
                src={require("../assets/share/facebook.png")}
                alt="facebook share"
                width={20}
              />
            </button>
            <button className="sendOther">
              <img
                src={require("../assets/share/twitter.png")}
                alt="twitter share"
                width={20}
              />
            </button>
            <button className="sendOther">
              <img
                src={require("../assets/share/gmail.png")}
                alt="email share"
                width={20}
              />
            </button>
          </div>

          <h3>Redeemed Invites</h3>
          <div id="referralList">
            <p>Nobody has signed up using your link yet.</p>
          </div>
        </div>
      </ContentWrapper>
    );
  }
}
